// eslint-disable-next-line
export default () => `id${Math.random().toString(16).slice(2)}`;
